import DOMPurify from 'dompurify'

export const createMarkup = (html: any) => {
  return {
    __html: DOMPurify.sanitize(html),
  }
}
